/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';

/**
 * 
 * @export
 * @interface PositionBase
 */
export interface PositionBase {
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    accountAlias?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    description: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof PositionBase
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof PositionBase
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof PositionBase
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    closePrice: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    marketValue: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    netExposure: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    grossExposure: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    costBasis?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    pnlUnrealized?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    returnUnrealized?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    side: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    referencePortfolio?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    allocationType?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    investmentAlgo: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    investmentSleeve: string;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    nav: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    marketValuePercentOfNav: number;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    coId?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    priceMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    primaryExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    cusip?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    sedol?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    mic?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    gicsCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    gicsSector?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    gicsIndustry?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    coupon?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    maturityDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    issueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    firstNoticeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    settlementMethod?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionBase
     */
    minTick?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    putCall?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    underlyingSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof PositionBase
     */
    ndvrChainId?: string;
}



/**
 * Check if a given object implements the PositionBase interface.
 */
export function instanceOfPositionBase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "closePrice" in value;
    isInstance = isInstance && "marketValue" in value;
    isInstance = isInstance && "netExposure" in value;
    isInstance = isInstance && "grossExposure" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "investmentAlgo" in value;
    isInstance = isInstance && "investmentSleeve" in value;
    isInstance = isInstance && "nav" in value;
    isInstance = isInstance && "marketValuePercentOfNav" in value;
    isInstance = isInstance && "brokerId" in value;

    return isInstance;
}

export function PositionBaseFromJSON(json: any): PositionBase {
    return PositionBaseFromJSONTyped(json, false);
}

export function PositionBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'accountAlias': !exists(json, 'account_alias') ? undefined : json['account_alias'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'aC': json['a_c'],
        'sId': json['s_id'],
        'description': json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'quantity': json['quantity'],
        'closePrice': json['close_price'],
        'marketValue': json['market_value'],
        'netExposure': json['net_exposure'],
        'grossExposure': json['gross_exposure'],
        'costBasis': !exists(json, 'cost_basis') ? undefined : json['cost_basis'],
        'pnlUnrealized': !exists(json, 'pnl_unrealized') ? undefined : json['pnl_unrealized'],
        'returnUnrealized': !exists(json, 'return_unrealized') ? undefined : json['return_unrealized'],
        'side': json['side'],
        'referencePortfolio': !exists(json, 'reference_portfolio') ? undefined : json['reference_portfolio'],
        'allocationType': !exists(json, 'allocation_type') ? undefined : json['allocation_type'],
        'investmentAlgo': json['investment_algo'],
        'investmentSleeve': json['investment_sleeve'],
        'nav': json['nav'],
        'marketValuePercentOfNav': json['market_value_percent_of_nav'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'primaryExchange': !exists(json, 'primary_exchange') ? undefined : json['primary_exchange'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'sedol': !exists(json, 'sedol') ? undefined : json['sedol'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'mic': !exists(json, 'mic') ? undefined : json['mic'],
        'gicsCode': !exists(json, 'gics_code') ? undefined : json['gics_code'],
        'gicsSector': !exists(json, 'gics_sector') ? undefined : json['gics_sector'],
        'gicsIndustry': !exists(json, 'gics_industry') ? undefined : json['gics_industry'],
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
        'maturityDate': !exists(json, 'maturity_date') ? undefined : json['maturity_date'],
        'issueDate': !exists(json, 'issue_date') ? undefined : json['issue_date'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : json['expiration_date'],
        'firstNoticeDate': !exists(json, 'first_notice_date') ? undefined : json['first_notice_date'],
        'settlementMethod': !exists(json, 'settlement_method') ? undefined : json['settlement_method'],
        'minTick': !exists(json, 'min_tick') ? undefined : json['min_tick'],
        'putCall': !exists(json, 'put_call') ? undefined : json['put_call'],
        'underlyingSymbol': !exists(json, 'underlying_symbol') ? undefined : json['underlying_symbol'],
        'brokerId': json['broker_id'],
        'ndvrChainId': !exists(json, 'ndvr_chain_id') ? undefined : json['ndvr_chain_id'],
    };
}

export function PositionBaseToJSON(value?: PositionBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'account_alias': value.accountAlias,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        'a_c': value.aC,
        's_id': value.sId,
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'quantity': value.quantity,
        'close_price': value.closePrice,
        'market_value': value.marketValue,
        'net_exposure': value.netExposure,
        'gross_exposure': value.grossExposure,
        'cost_basis': value.costBasis,
        'pnl_unrealized': value.pnlUnrealized,
        'return_unrealized': value.returnUnrealized,
        'side': value.side,
        'reference_portfolio': value.referencePortfolio,
        'allocation_type': value.allocationType,
        'investment_algo': value.investmentAlgo,
        'investment_sleeve': value.investmentSleeve,
        'nav': value.nav,
        'market_value_percent_of_nav': value.marketValuePercentOfNav,
        'sc_id': value.scId,
        'co_id': value.coId,
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
        'symbol': value.symbol,
        'primary_exchange': value.primaryExchange,
        'cusip': value.cusip,
        'isin': value.isin,
        'sedol': value.sedol,
        'country': value.country,
        'mic': value.mic,
        'gics_code': value.gicsCode,
        'gics_sector': value.gicsSector,
        'gics_industry': value.gicsIndustry,
        'issuer': value.issuer,
        'coupon': value.coupon,
        'maturity_date': value.maturityDate,
        'issue_date': value.issueDate,
        'expiration_date': value.expirationDate,
        'first_notice_date': value.firstNoticeDate,
        'settlement_method': value.settlementMethod,
        'min_tick': value.minTick,
        'put_call': value.putCall,
        'underlying_symbol': value.underlyingSymbol,
        'broker_id': value.brokerId,
        'ndvr_chain_id': value.ndvrChainId,
    };
}

